/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TransientCalculationPoint } from './TransientCalculationPoint';
/**
 * Drive Cycle.
 */
export type DriveCycle = {
    id?: string; // TODO: Keep this
    item_type?: DriveCycle.item_type;
    name?: string;
    number_of_points?: number; // TODO: Keep this
    total_distance?: number; // TODO: Keep this
    total_time?: number; // TODO: Keep this
    points?: Array<TransientCalculationPoint>;
};
export namespace DriveCycle {
    export enum item_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
}

